// sessionStorage, never localStorage: it is scoped to this tab and gone when the
// tab closes, and the API has no public endpoint that returns a draft's password
// to a guest, so the browser is the only place a reload can read it back from.
// A single entry is kept, for the draft the guest is working on.
const STORAGE_KEY = 'qr-guest-draft-password'

export const readGuestDraftPassword = (qrId: string): string | null => {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY)
		if (!raw) {
			return null
		}
		// unknown: storage can hold anything (another version, manual edits), so it is narrowed below
		const entry: unknown = JSON.parse(raw)
		if (
			typeof entry === 'object' &&
			entry !== null &&
			'qrId' in entry &&
			'password' in entry &&
			entry.qrId === qrId &&
			typeof entry.password === 'string'
		) {
			return entry.password
		}
		return null
	} catch {
		return null
	}
}

export const writeGuestDraftPassword = (qrId: string, password: string) => {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ qrId, password }))
	} catch {
		// Storage unavailable: a reload has nothing to restore, same as no entry
	}
}

export const clearGuestDraftPassword = () => {
	try {
		sessionStorage.removeItem(STORAGE_KEY)
	} catch {
		// Nothing to clear if storage is unavailable
	}
}
